export const leadStory = {
  tag: "深度 · 头条深扒",
  title: "从「金句担当」到全网追问：一位综艺常客的三年人设考古",
  intro:
    "翻遍三年节目物料、路透与粉丝站存图，我们把这位艺人的高光发言、隐晦表态与迟到回应逐帧对位，整理成一条可倒带的时间轴。所谓翻车，往往从一句看似无害的玩笑开始。",
  meta: ["深扒耗时 9 天", "引用物料 47 份", "最后更新 2 小时前"],
  img: "https://readdy.ai/api/search-image?query=cinematic%20moody%20backstage%20of%20a%20television%20studio%20with%20soft%20red%20and%20warm%20amber%20stage%20lighting%20casting%20long%20shadows%2C%20silhouette%20of%20a%20person%20sitting%20alone%20facing%20away%20under%20a%20spotlight%2C%20editorial%20documentary%20photography%2C%20grainy%20film%20texture%2C%20deep%20dark%20tones%20with%20dramatic%20contrast&width=1600&height=1000&seq=gossip-lead-01&orientation=landscape",
};

export const featured = [
  {
    tag: "顶流塌房",
    title: "直播翻车被逐帧回放，代言方连夜表态撤物料",
    desc: "一场看似正常的品牌直播，因几句即兴发言在评论区引爆，随后被做成表情包与逐句复盘全网刷屏。",
    time: "40 分钟前",
    heat: "986万",
    img: "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20neon%20lit%20television%20monitor%20showing%20blurred%20live%20broadcast%20glare%20in%20a%20dark%20newsroom%2C%20crimson%20and%20magenta%20reflections%2C%20cinematic%20editorial%20photography%2C%20high%20contrast%20film%20noir%20mood&width=800&height=640&seq=gossip-f1&orientation=portrait",
  },
  {
    tag: "合约纠纷",
    title: "工作室声明与旧合同被比对，三大矛盾点浮出",
    desc: "双方各执一词的口水仗之外，评论区扒手把合同条款与公开发言逐条对表，整理出最容易被忽略的三处出入。",
    time: "1 小时前",
    heat: "631万",
    img: "https://readdy.ai/api/search-image?query=stack%20of%20paper%20contracts%20with%20fountain%20pen%20and%20reading%20glasses%20on%20a%20desk%20bathed%20in%20warm%20desk%20lamp%20light%2C%20dark%20background%20with%20amber%20tones%2C%20editorial%20still%20life%20photography%2C%20documentary%20texture&width=800&height=640&seq=gossip-f2&orientation=portrait",
  },
  {
    tag: "旧账重提",
    title: "五年前一段访谈被挖出，评论区直呼「预判了现在」",
    desc: "当新旧言论被并排放置，曾被视为「口无遮拦」的话，此刻读来竟像一句精准预言。考古帖浏览量仍在爬升。",
    time: "2 小时前",
    heat: "459万",
    img: "https://readdy.ai/api/search-image?query=old%20fashioned%20microphone%20and%20retro%20tape%20recorder%20in%20a%20dim%20interview%20room%2C%20warm%20side%20lighting%2C%20dust%20particles%20in%20air%2C%20nostalgic%20editorial%20photography%2C%20sepia%20and%20crimson%20undertones&width=800&height=640&seq=gossip-f3&orientation=portrait",
  },
  {
    tag: "人设崩塌",
    title: "「宠粉人设」被旧站姐存档打脸，粉丝站宣布停更",
    desc: "多年积累的粉丝信任，能否扛住一张旧图的时间差？本期我们从应援史与花絮物料里还原完整叙事。",
    time: "3 小时前",
    heat: "387万",
    img: "https://readdy.ai/api/search-image?query=single%20abandoned%20concert%20spotlight%20on%20an%20empty%20arena%20stage%20with%20scattered%20fan%20banner%20lights%20off%2C%20moody%20dark%20atmosphere%2C%20deep%20red%20glow%2C%20cinematic%20editorial%20photography%2C%20lonely%20and%20dramatic&width=800&height=640&seq=gossip-f4&orientation=portrait",
  },
];

export const hotRank = [
  { rank: 1, title: "代言解约连锁反应持续发酵", heat: "1862万", up: true, delta: "较昨日 +4" },
  { rank: 2, title: "工作室深夜长文回应，删改记录被截", heat: "1520万", up: true, delta: "较昨日 +2" },
  { rank: 3, title: "「综艺名场面」考古串烧刷屏", heat: "1214万", up: false, delta: "较昨日 -1" },
  { rank: 4, title: "被指抄袭的编舞对比视频", heat: "980万", up: true, delta: "较昨日 +7" },
  { rank: 5, title: "狗仔实拍：深夜同行疑新恋情", heat: "766万", up: true, delta: "新上榜" },
  { rank: 6, title: "五年前访谈被重新解读", heat: "592万", up: false, delta: "较昨日 -3" },
  { rank: 7, title: "粉丝站集体停更公告合集", heat: "431万", up: false, delta: "较昨日 -2" },
  { rank: 8, title: "商务合作疑似被暗中撤除", heat: "287万", up: true, delta: "新上榜" },
];

export const talks = [
  { idx: "01", cat: "争议", title: "「脱口而出」算言论翻车吗？语境考古给出答案", read: "12.6万", comment: "4083" },
  { idx: "02", cat: "实锤", title: "商用图库素材被当生活照晒？修图痕迹逐层还原", read: "9.8万", comment: "3127" },
  { idx: "03", cat: "追问", title: "经纪团队前后三版通稿对比，措辞变动耐人寻味", read: "8.4万", comment: "2765" },
  { idx: "04", cat: "复盘", title: "一场庆功宴上的座位图，被扒出圈内关系新线索", read: "7.1万", comment: "1930" },
  { idx: "05", cat: "冷知识", title: "那些「查无此人」的早期作品，去了哪里？", read: "5.5万", comment: "1204" },
  { idx: "06", cat: "速递", title: "本人仅回复一条评论，其余质疑沉默为哪般", read: "4.2万", comment: "988" },
];

export const people = [
  {
    name: "林姓综艺艺人",
    role: "综艺 · 塌房观察",
    hits: "深扒 23 篇",
    status: "持续跟进",
    img: "https://readdy.ai/api/search-image?query=portrait%20of%20an%20artist%20in%20silhouette%20wearing%20a%20trench%20coat%20turned%20away%20from%20camera%20against%20a%20dark%20warm%20brown%20studio%20background%20with%20subtle%20red%20rim%20light%2C%20editorial%20fashion%20magazine%20photography%2C%20film%20grain&width=600&height=760&seq=gossip-p1&orientation=portrait",
  },
  {
    name: "沈姓唱作人",
    role: "音乐 · 言论考古",
    hits: "深扒 17 篇",
    status: "热度上升",
    img: "https://readdy.ai/api/search-image?query=blurred%20figure%20holding%20a%20microphone%20on%20a%20dark%20stage%20with%20single%20amber%20spotlight%20from%20above%2C%20face%20in%20shadow%2C%20moody%20editorial%20concert%20photography%2C%20warm%20crimson%20and%20gold%20tone&width=600&height=760&seq=gossip-p2&orientation=portrait",
  },
  {
    name: "周姓选秀爱豆",
    role: "选秀 · 物料比照",
    hits: "深扒 21 篇",
    status: "今日新增",
    img: "https://readdy.ai/api/search-image?query=young%20performer%20seen%20from%20behind%20dancing%20under%20colorful%20but%20muted%20rehearsal%20hall%20lights%2C%20back%20turned%20to%20camera%2C%20editorial%20photojournalism%2C%20soft%20noise%20and%20deep%20shadows&width=600&height=760&seq=gossip-p3&orientation=portrait",
  },
  {
    name: "赵姓主持人",
    role: "主持 · 言论比照",
    hits: "深扒 15 篇",
    status: "平稳",
    img: "https://readdy.ai/api/search-image?query=empty%20television%20hosting%20desk%20with%20studio%20camera%20silhouette%20reflecting%20blue%20and%20warm%20light%20but%20mostly%20dark%2C%20no%20person%20visible%2C%20editorial%20documentary%20style%2C%20cinematic%20mood&width=600&height=760&seq=gossip-p4&orientation=portrait",
  },
  {
    name: "孙姓演员",
    role: "影视 · 合约归档",
    hits: "深扒 29 篇",
    status: "档案最全",
    img: "https://readdy.ai/api/search-image?query=theater%20stage%20curtains%20closed%20in%20a%20dark%20grand%20theater%20with%20single%20warm%20followspot%2C%20no%20actor%20visible%2C%20editorial%20photography%2C%20dramatic%20chiaroscuro%2C%20burgundy%20and%20gold&width=600&height=760&seq=gossip-p5&orientation=portrait",
  },
  {
    name: "吴姓网红",
    role: "网红 · 直播实锤",
    hits: "深扒 13 篇",
    status: "今日新增",
    img: "https://readdy.ai/api/search-image?query=phone%20screen%20glow%20illuminating%20dark%20room%20with%20reflection%20of%20a%20person%20holding%20phone%2C%20face%20hidden%2C%20cinematic%20editorial%20photography%2C%20high%20contrast%20noir%20mood%20with%20warm%20tones&width=600&height=760&seq=gossip-p6&orientation=portrait",
  },
];

export const feed = [
  { time: "14:20", platform: "微博", text: "某账号发布声明「保留法律追究权利」，删改记录随即被网友截图留证。", tag: "回应" },
  { time: "13:05", platform: "抖音", text: "一博主放出演唱会「假唱」逐段声纹比对，播放量一小时破两百万。", tag: "实锤" },
  { time: "11:47", platform: "豆瓣", text: "小组内流传的「剧组名单」被指与官方开机照对不上，讨论持续置顶。", tag: "存疑" },
  { time: "10:31", platform: "微博", text: "某品牌官微悄悄移除了代言相关置顶，评论区开始涌入求证留言。", tag: "动向" },
  { time: "09:12", platform: "小红书", text: "前助理账号发文忆当年，字里行间暗示待遇落差，引广泛共鸣。", tag: "旧账" },
  { time: "08:03", platform: "抖音", text: "「名场面考古」合集更新第三期，原作者称将整理完整素材库。", tag: "复盘" },
];

export const timelineEvents = [
  { date: "05-02", month: "2026.05", title: "首条异样动态出现", desc: "账号在深夜发布一条语焉不详的动态，随后秒删，成为考古第一线索。", votes: "被转发 3.2 万次" },
  { date: "05-11", month: "2026.05", title: "旧访谈片段被重翻", desc: "半年前的一段采访被剪辑号重新上传，评论区指出多处前后矛盾。", votes: "登上热搜榜" },
  { date: "06-03", month: "2026.06", title: "品牌方悄悄调整物料", desc: "官方渠道合作图与置顶内容被陆续替换，粉丝发现后大量截图留档。", votes: "粉丝群热议" },
  { date: "07-19", month: "2026.07", title: "工作室发布首份声明", desc: "声明措辞被逐句拆解，与旧合同比对后出现三处争议焦点。", votes: "24 小时 900 万阅读" },
  { date: "08-27", month: "2026.08", title: "当事人深夜单独回应", desc: "仅回复一条评论，其余提问均未作答，沉默本身成为新一轮焦点。", votes: "评论量 12 万" },
];

export const archiveGroups = [
  {
    cat: "顶流塌房档案",
    desc: "从代言解约到应援崩塌的高能汇总",
    count: 47,
    accent: true,
    items: ["「直播翻车」逐帧复盘全纪录", "五年人设考古与名场面串烧", "品牌连夜解约完整时间轴"],
    img: "https://readdy.ai/api/search-image?query=collage%20of%20newspaper%20clippings%20and%20phone%20screens%20pinned%20on%20a%20dark%20corkboard%20with%20red%20thread%20connecting%20dots%2C%20moody%20investigation%20board%2C%20editorial%20photography%2C%20warm%20lamplight%20and%20deep%20shadows&width=900&height=620&seq=gossip-a1&orientation=landscape",
  },
  {
    cat: "言论翻车合集",
    desc: "一句不合时宜的话可以引发多少连锁",
    count: 63,
    accent: false,
    items: ["访谈旧话被重新解读的十个案例", "直播即兴发言逐句语境还原", "道歉声明措辞演变史"],
    img: "https://readdy.ai/api/search-image?query=old%20newspapers%20with%20highlighted%20quotes%20and%20red%20underlines%20on%20a%20dark%20wood%20table%2C%20magnifying%20glass%20over%20text%2C%20editorial%20research%20photography%2C%20moody%20warm%20lighting&width=900&height=620&seq=gossip-a2&orientation=landscape",
  },
  {
    cat: "合约纠纷深度",
    desc: "合同条款与公开言论的逐条对表",
    count: 38,
    accent: false,
    items: ["工作室声明与旧合同三大矛盾点", "解约函措辞中的隐藏信息", "分账条款引发的圈内讨论"],
    img: "https://readdy.ai/api/search-image?query=documents%20with%20signatures%20and%20stamp%20seals%20scattered%20on%20a%20desk%2C%20gold%20paperclip%20and%20fountain%20pen%2C%20dark%20background%20with%20warm%20amber%20desk%20lamp%2C%20editorial%20still%20life&width=900&height=620&seq=gossip-a3&orientation=landscape",
  },
  {
    cat: "圈内考古串烧",
    desc: "把被遗忘的物料一条条捡回来",
    count: 55,
    accent: false,
    items: ["早期作品「查无此人」之谜", "应援史里的信任崩塌瞬间", "颁奖礼后台座位图背后的关系网"],
    img: "https://readdy.ai/api/search-image?query=rows%20of%20old%20video%20tapes%20and%20polaroid%20photos%20on%20shelves%20in%20a%20dim%20archive%20room%2C%20warm%20single%20bulb%20lighting%2C%20nostalgic%20editorial%20photography%2C%20film%20grain%20texture&width=900&height=620&seq=gossip-a4&orientation=landscape",
  },
];

export const topRank = [
  { name: "林姓综艺艺人", score: "9.6", trend: "↑", desc: "直播言论 + 旧访谈，双线发酵" },
  { name: "吴姓网红", score: "9.2", trend: "新", desc: "假唱声纹比对引发大范围转载" },
  { name: "沈姓唱作人", score: "8.8", trend: "↑", desc: "演出海报被指物料重复使用" },
  { name: "周姓选秀爱豆", score: "8.5", trend: "→", desc: "编舞抄袭对比热度不减" },
  { name: "孙姓演员", score: "8.1", trend: "→", desc: "合约纠纷讨论进入第三周" },
  { name: "赵姓主持人", score: "7.6", trend: "↓", desc: "旧言论被考古后热度回落" },
];

export const hotKeywords = ["塌房", "言论翻车", "合约解约", "应援停更", "假唱比对", "旧账重提", "深夜回应", "品牌撤物"];